import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/authStore.js";

import { useTranslation } from "react-i18next";

export default function WorkspacePicker() {
  const { t } = useTranslation("workspace_picker");
  const navigate = useNavigate();
  const workspaces = useAuthStore((s) => s.workspaces);
  const setWorkspace = useAuthStore((s) => s.setWorkspace);

  function handlePick(workspace) {
    setWorkspace(workspace);
    navigate("/dashboard", { replace: true });
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-50">
      <div className="w-full max-w-sm">
        <div className="mb-6 text-center">
          <h1 className="text-2xl font-bold text-gray-900">{t("title")}</h1>
          <p className="mt-1 text-sm text-gray-500">
            {t("subtitle")}
          </p>
        </div>

        <div className="space-y-2">
          {workspaces.map((workspace) => (
            <button
              key={workspace.id}
              type="button"
              onClick={() => handlePick(workspace)}
              className="flex w-full items-center gap-4 rounded-xl border border-gray-200 bg-white px-5 py-4 text-left shadow-sm transition hover:border-teal-400 hover:shadow-md"
            >
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-gray-100 text-sm font-bold uppercase text-gray-600">
                {workspace.name.slice(0, 2)}
              </div>
              <div className="min-w-0 flex-1">
                <p className="truncate font-semibold text-gray-900">{workspace.name}</p>
                <p className="truncate text-xs text-gray-400 capitalize">{workspace.plan} · {workspace.role}</p>
              </div>
              <svg className="h-4 w-4 shrink-0 text-gray-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
              </svg>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
